export default "__VITE_ASSET__Cp94TKH2__"